// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__2AkxX","error":"AnswerItem_error__1dk5-","success":"AnswerItem_success__7nSvj"};